import { isCapacitor } from './isCapacitor'

/**
 * Safely imports Capacitor Apple Sign-In to avoid module resolution errors
 */
export const SignInWithApple = {
  authorize: async options => {
    if (!isCapacitor) {
      throw new Error('Apple Sign-In is only available on mobile platforms')
    }

    try {
      // Use dynamic import with error handling
      const AppleSignInModule = require('@capacitor-community/apple-sign-in')

      if (AppleSignInModule && AppleSignInModule.SignInWithApple) {
        return await AppleSignInModule.SignInWithApple.authorize(options)
      }

      // Fallback to direct import if available
      const {
        SignInWithApple: AppleSignIn,
      } = require('@capacitor-community/apple-sign-in')
      return await AppleSignIn.authorize(options)
    } catch (error) {
      console.warn('Apple Sign-In not available:', error.message)
      throw new Error('Apple Sign-In is not available on this platform')
    }
  },
}
